<!-- 质保金支付申请表 -->
<template>
	<div class="pages">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>
		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" size="large" type="primary"> 提交 </Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'

	import {
		initWxConfig
	} from "../api/jssdk.js";
	import stringUtils from "../assets/js/stringUtil.js";

	import {
		getDepartmentRelationByName,
		getDepartmentRelationById,
		getDepartmentInfo
	} from '@/api/department'
	import {
		AllowApplyForVerify,
			getTemplateInfo,
			getFlowTemplate
	} from '@/api/approval'
	
	import {
		formatDate
	} from '@/utils/date'

	var templateData = {
		TemplateContent: {
			Controls: []
		}
	};
	var logInfo = null;

	var isSubmit = false;

	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				"templateData": templateData,
				asd: 123,
				spNo: null,
				flowId:null,
				isDisabled:null
			}
		},
		mounted() { //页面挂载
			initWxConfig(this);
			this.spNo = this.$route.query.spNo;
			this.templateId = this.$route.query.templateId;
			this.flowId = this.$route.query.flowId;
			this.getTemplate();
			stringUtils.setAddIsShow(true);
			
		},
		created() {
		},
		methods: { //方法
			
			getDepartmentDetailInfo: async function(deptId) {
				var departName = "";
				await getDepartmentInfo(deptId).then(res => {
					departName = res.Body.FullName;
				});
				return departName;
				
			},
			getTemplate() {
				var that = this;
				// console.log(stringUtils.GetQueryString("templateId"))
				that.$http({
					url: that.$httpUrl.getTemplate + "?templateId=" + stringUtils.GetQueryString("templateId"),
					method: "get",
				}).then(async res => {
					if (res.data == null || res.data.ErrCode != 0) {
						that.$Message.error({ //error： 错误信息、success：成功、info：普通、warning：警告
							background: true,
							content: '模板获取错误'
						});
						return;
					}
					var controls = res.data.Body;
					that.templateData = res.data.Body;
					if (that.templateData == null) {
						alert("模板获取错误");
						return;
					}
					logInfo = JSON.parse(localStorage.getItem('logInfo'));
					if (logInfo == null) {
						logInfo = JSON.parse(stringUtils.getCookies("logInfo"));
					}
					if(logInfo.fullName.indexOf("行政部")==-1&&logInfo.fullName.indexOf("信息中心")==-1&&logInfo.EmpNo != "SC18008706"){
						this.Message({
							message: '没有申请权限',
							type: 'error',
							duration: 1000
						});
						this.isDisabled = true;
					}
					await that.getFlowTemplateInfo();
					for (var i = 0; i < controls.TemplateContent.Controls.length; i++) {
							if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "部门") {
								that.templateData.TemplateContent.Controls[i].Value = logInfo.DeptName;
							} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "人员") {
								that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpName;
							} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "工号") {
								that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpNo;
							} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "入职时间") {
								that.templateData.TemplateContent.Controls[i].Value = logInfo.InCompanyDate;
							} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "联系电话") {
								that.templateData.TemplateContent.Controls[i].Value = logInfo.Mobile;
							} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "职位") {
								that.templateData.TemplateContent.Controls[i].Value = logInfo.PositionName;
							} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "申请时间") {
								let date = new Date();
								that.templateData.TemplateContent.Controls[i].Value = formatDate(date,"yyyy-MM-dd");
							} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "端口费用承担部门") {
								that.templateData.TemplateContent.Controls[i].Value = logInfo.DeptName;
							}else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "行政主任") {
								
								if(logInfo.fullName.indexOf("信息中心")>-1){
									that.templateData.TemplateContent.Controls[i].Values=[];
									that.templateData.TemplateContent.Controls[i].Values.push(that.$store.state.defaultMember);
								}
								that.templateData.TemplateContent.Controls[i].IsShow = false;
							}else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "逐级审批") {
								if(logInfo.fullName.indexOf("信息中心")>-1){
									that.templateData.TemplateContent.Controls[i].Values=[];
									that.templateData.TemplateContent.Controls[i].Values.push(that.$store.state.defaultMember);
								}
								that.templateData.TemplateContent.Controls[i].IsShow = false;
								
							}else if(that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "选择申请部门"){
								if(logInfo.fullName.indexOf("信息中心")>-1){
									that.templateData.TemplateContent.Controls[i].IsShow = false;
									that.templateData.TemplateContent.Controls[i].Values = [["1","四川中原"]];
								}
							}else if(that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "流程条件"){
								that.templateData.TemplateContent.Controls[i].Value = "0";
							}
						}
					  
					var controlsLength = controls.TemplateContent.Controls.length;
					for (var j = 0; j < controlsLength; j++) {
						var controlsData = controls.TemplateContent.Controls[j];
						var departs = logInfo.fullName.split("/");
						if (that.applyTemplateData != null) {
							var data = that.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == controlsData.Property.Title[0].Text
							});
							if (controlsData.Property.Title[0].Text == "项目") {
								controlsData.addIsShow = false;
								var i = 1;
								that.applyTemplateData.TemplateContent.Controls.forEach(async (applyData) => {
									if (applyData.Property.Title[0].Text.indexOf("项目") > -1) {
										if (applyData.Property.Title[0].Text != "项目") {
											
											var AddTable = JSON.stringify(controlsData);
											AddTable = JSON.parse(AddTable);
											AddTable.Property.Title[0].Text = AddTable.Property.Title[0].Text + i;
											
											// AddTable.Property.Id = "Table-" + this.guid();
											AddTable.addIsShow = false;
											AddTable.Config.Table.Children.forEach(forDisable => {
												forDisable.Disable = true;
											});
											controls.TemplateContent.Controls.splice(j + i, 0, AddTable);
											i++;
										}
									}
								});
								controlsData.Config.Table.Children.forEach(childItem => {
									childItem.Disable = false;
								})
								break;
							}
						}
					}
					for (var j = 0; j < controlsLength; j++) {
						var controlsData = controls.TemplateContent.Controls[j];
						var departs = logInfo.fullName.split("/");
						if (that.applyTemplateData != null) {
							var data = that.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == controlsData.Property.Title[0].Text
							});
							if (controlsData.Property.Title[0].Text == "供应商") {
								controlsData.addIsShow = false;
								var i = 1;
								that.applyTemplateData.TemplateContent.Controls.forEach(async (applyData) => {
									if (applyData.Property.Title[0].Text.indexOf("供应商") > -1) {
										if (applyData.Property.Title[0].Text != "供应商") {
											
											var AddTable = JSON.stringify(controlsData);
											AddTable = JSON.parse(AddTable);
											AddTable.Property.Title[0].Text = AddTable.Property.Title[0].Text + i;
											
											// AddTable.Property.Id = "Table-" + this.guid();
											AddTable.addIsShow = false;
											AddTable.Config.Table.Children.forEach(forDisable => {
												forDisable.Disable = true;
											});
											controls.TemplateContent.Controls.splice(j + i, 0, AddTable);
											i++;
										}
									}
								});
								controlsData.Config.Table.Children.forEach(childItem => {
									childItem.Disable = false;
								})
								break;
							}
						}
					}
					this.templateData = this.assignControl(controls, logInfo);
					this.templateData = await this.assignControlBySpNo(controls, null, that.flowId);
					
				});
				
			},
			getFlowTemplateInfo: async function() {
				if(this.flowId==null||this.flowId==undefined||this.flowId.length<=0){
						return;
				}
				await getFlowTemplate(this.flowId).then(response => {
					this.applyTemplateData = response.Body;
				});
			},
			clickChoose:async function(dataVal, name) {
				var htel = this;
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, async function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var templateContent = htel.templateData.TemplateContent;
						var depart = res.result.departmentList[0]; // 已选的部门列表
						dataVal.Values.push([depart.id, depart.name]);
						var departFullName = ""
						getDepartmentInfo(depart.id).then(res => {
							departFullName = res.Body.FullName;
							var departName = departFullName.split("/");
							templateContent.Controls.forEach(async (item, index) => {
								if (item.Property.Title[0].Text == "流程编号") {
									item.IsShow = false;
								}
								
								if(departName.indexOf("非营业部") > -1){
									if (item.Property.Title[0].Text == "流程条件") {
										item.Value = "1";
									}
									if (item.Property.Title[0].Text == "逐级审批") {
										item.Values = [];
										item.Values.push(htel.$store.state.defaultMember);
									}
									if (item.Property.Title[0].Text == "行政主任") {
										item.Values=[];
										item.Values.push(htel.$store.state.defaultMember);
									}
								}else if(departFullName.indexOf("二级市场") > -1||departFullName.indexOf("代理") > -1){
									if (item.Property.Title[0].Text == "流程条件") {
										item.Value = "2";
									}
									if (item.Property.Title[0].Text == "逐级审批") {
										item.Values = [];
										item.Values.push(htel.$store.state.defaultMember);
									}
									if (item.Property.Title[0].Text == "行政主任") {
										item.Values=[];
										item.Values.push(htel.$store.state.defaultMember);
									}
								}else if(departFullName.indexOf("按揭金融服务中心") > -1){
									if (item.Property.Title[0].Text == "流程条件") {
										item.Value = "3";
									}
									if (item.Property.Title[0].Text == "逐级审批") {
										item.Values = [];
										item.Values.push(htel.$store.state.defaultMember);
									}
									if (item.Property.Title[0].Text == "行政主任") {
										item.Values=[];
										item.Values.push(htel.$store.state.defaultMember);
									}
								}else if(departFullName.indexOf("房友圈") > -1){
									if (item.Property.Title[0].Text == "流程条件") {
										item.Value = "4";
									}
									if (item.Property.Title[0].Text == "逐级审批") {
										item.Values = [];
										item.Values.push(htel.$store.state.defaultMember);
									}
									if (item.Property.Title[0].Text == "行政主任") {
										item.Values=[];
										item.Values.push(htel.$store.state.defaultMember);
									}
								}else if(departFullName.indexOf("工商铺") > -1){
									if (item.Property.Title[0].Text == "流程条件") {
										item.Value = "5";
									}
									if (item.Property.Title[0].Text == "逐级审批") {
										item.Values = [];
										item.Values.push(htel.$store.state.defaultMember);
									}
									if (item.Property.Title[0].Text == "行政主任") {
										item.Values=[];
										item.Values.push(htel.$store.state.defaultMember);
									}
								}else if (departFullName.indexOf("住宅部") > -1) {
									if (item.Property.Title[0].Text == "流程条件") {
										item.Value = "6";
									}
									if (item.Property.Title[0].Text == "逐级审批") {
										item.Values = [];
										var val =  await htel.getDepartmentRelation(depart.id, "区域董事",true);
										if (val != null && val.length > 0) {
											item.Values.push(val[0]);
										}
										val = await htel.getDepartmentRelation(depart.id, "大区董事",true);
										if (val != null && val.length > 0) {
											item.Values.push(val[0]);
										}
										val = await htel.getDepartmentRelation(depart.id, "总经理",true);
										if (val != null && val.length > 0) {
											item.Values.push(val[0]);
										}
										//====2021-9-3
										item.Values.push(htel.$store.state.defaultMember)
										//====
										item.IsShow = false;
										if(item.Values.length == 0){
											//审批节点无人，跳过
											item.Values.push(htel.$store.state.defaultMember);
										}
									}else if (item.Property.Title[0].Text == "行政主任") {
												item.Values=[];
												item.Values = await htel.getDepartmentRelation(depart.id, "行政主任");
												if (item.Values == null || item.Values.length <= 0) {
													//审批节点无人，跳过
													item.Values.push(htel.$store.state.defaultMember);
												}
											}
								}
							})
							dataVal.Value = depart.name;
						});
					}
				})
			},
			getTextVal() {
			},
			tableOperation(val, type, datas) {
				this.tableoperation(val, type, datas, this);
			},
			getSelectorVal(val, name) {

			},
			submit() {
				let that = this;
				
				var controls = that.templateData.TemplateContent.Controls;
				
				for (var i = 0; i < controls.length; i++) {
					if (controls[i].Property != null && controls[i].Property.Require == 1 && ((controls[i].Value == null || controls[i]
							.Value == '') && (controls[i].Values == null || controls[i].Values == ''))) {
						that.$message.error(controls[i].Property.Title[0].Text + "未填写,请填写完整");
						isSubmit = false;
						return;
					}
					if (controls[i].Property.Title[0].Text == "流程条件") {
						if (controls[i].Value == -1) {
							that.$message.error("没有申请权限");
							return;
						}
					}
				}
				if (isSubmit) {
					that.$message.info("已提交");
					return;
				}
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请部门："+control2.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "是否关铺"})[0];
				var control1Text=control1.Config.Selector.Options.filter(t=>{return t.Key==control1.Value})[0].Value[0].Text;
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "项目"})[0]
				var control4 = this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "实际支付金额"})[0];
				
				var control5 = control3.Config.Table.Children.filter(t=>{return t.Property.Title[0].Text == "项目名称"})[0];
				
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"项目名称："+control5.Value,"Lang":"zh_CN"});
				
				
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"是否关铺："+control1Text+" 实际支付金额:"+control4.Value,"Lang":"zh_CN"});
				
				
				
				
				SummaryList.push(info);
				this.templateData.SummaryList=SummaryList;
				isSubmit = true;
				that.$http.post(that.$httpUrl.startProcess + "?temId=" + stringUtils.GetQueryString("templateId") + "&empNo=" +
					logInfo.EmpNo + "&spNo=" + stringUtils.GetQueryString("spNo"), that.templateData).
				then(res => {
					isSubmit = false;
					if (res.data.ErrCode == 0) {
						that.$message.info("提交成功");
						that.$router.push("/index");
					} else {
						that.$message.error(res.data.ErrMsg);
					}
				}, err => {
				});
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
